<div class="action-bar">
  @for (action of actionsToShow; track action) {
    <button
      class="action-btn"
      (click)="handleAction(action)"
      [title]="action.tooltip">
      <mat-icon>{{ action.isActive ? action.onIcon : action.offIcon }}</mat-icon>
    </button>
  }
</div>
